<div class="kt-portlet container">
	<div class="kt-portlet__head">
		<div class="encabezado mt-3">
			<h1 class="titulo"><i class="fas fa-users"></i>&nbsp;Clientes</h1>
		</div>
		<div class="mt-3">
			<button style="margin-right: 20px;" mat-raised-button (click)="regresar()"><i
					class="fas fa-long-arrow-alt-left"></i>&nbsp;Regresar</button>
			<kt-boton-exportar-tabla [tipoBoton]="'grid'" [nombreArchivo]="'Clientes'" [datos]="datosReporte">
			</kt-boton-exportar-tabla>
		</div>
	</div>
	<mat-divider></mat-divider>
	<div class="kt-portlet__body">
		<div class="kt-section">
			<div class="kt-section__content">
				<div class="contenedor-modal">
					<div class="data-grid">
						<dx-data-grid id="gridContainer" [dataSource]="clientes" [showBorders]="true"
							[rowAlternationEnabled]="true">
							<dxo-paging [pageSize]="7"></dxo-paging>
							<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[7, 10, 50, 100]"
								[showInfo]="true">
							</dxo-pager>
							<dxo-group-panel [emptyPanelText]="mensajeAgrupar" [visible]="true"></dxo-group-panel>
							<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
							<dxo-header-filter [visible]="showHeaderFilter"></dxo-header-filter>
							<ng-container>
								<dxi-column caption="Acciones" cellTemplate="Abrir" alignment="center" [width]="120">
								</dxi-column>
							</ng-container>
							<dxi-column dataField="nombre" caption="Nombre" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<div *dxTemplate="let d of 'Abrir'" style="text-align: center;">
								<ng-container>
									<dx-button valueExpr="id" id="botonWhiteBlue" class="btnAcciones"
										(click)="verGaleria(d.data.id)">
										<i class="fa fa-images"></i>
									</dx-button>
								</ng-container>
							</div>
						</dx-data-grid>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
